import { NumericFormat, NumberFormatValues  } from 'react-number-format';
import * as React from 'react';

interface Props {
  readonly value?: string;
  readonly onValueChange?: any;
  readonly onChange?: (value: string) => void;
  readonly placeholder?: string;
  readonly style?: any;
  readonly className?: string;
  readonly disabled?: boolean;
  readonly allowNegative?: boolean;
  readonly onBlur?: (value: string) => void;
}

class BelfiusCurrencyInput extends React.Component<Props> {
  render() {
    return (
      <NumericFormat
        className={this.props.className}
        style={this.props.style}
        disabled={this.props.disabled}
        value={this.props.value}
        decimalSeparator=','
        thousandSeparator='.'
        decimalScale={2}
        valueIsNumericString={true}
        allowNegative={this.props.allowNegative}
        fixedDecimalScale={true}
        placeholder={this.props.placeholder}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          if (this.props.onChange) { this.props.onChange(event.target.value); }
        }}
        onValueChange={(values: NumberFormatValues) => {
                  if (this.props.onValueChange) {
                    this.props.onValueChange(values);
                  }
                }}
        onBlur={(event: React.ChangeEvent<HTMLInputElement>) => {
          if (this.props.onBlur) { this.props.onBlur(event.target.value); }
        }}
      />
    );
  }
}

export { BelfiusCurrencyInput };
